// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Q\\+Xj[data-v-daea8416]{position:relative;padding:24px}.gWPX[data-v-daea8416]{margin-bottom:56px;font-size:1rem;color:#aea1ce;line-height:24px}.Ijnc[data-v-daea8416]{margin-bottom:32px}.wt9L[data-v-daea8416]{text-align:center}.u5kq[data-v-daea8416]{margin-bottom:16px;margin-left:auto;margin-right:auto}.nJ9j[data-v-daea8416]{margin-bottom:32px}@media screen and (min-width:1024px){._7Hvb .Ewqx[data-v-daea8416]{width:220px;margin-left:auto;margin-right:auto}._7Hvb ._0hC2[data-v-daea8416]{margin-left:32px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp__wrap": "Q+Xj",
	"comp__title": "gWPX",
	"comp__radio": "Ijnc",
	"comp__confirm": "wt9L",
	"comp__icon": "u5kq",
	"comp__discription": "nJ9j",
	"comp": "_7Hvb",
	"comp__button": "Ewqx",
	"comp__radios": "_0hC2"
};
module.exports = ___CSS_LOADER_EXPORT___;
